import { defineMessages } from 'react-intl';

const translations = {
  noParcelMessage: {
    id: 'parcel.noParcelMessage',
    defaultMessage: 'No parcel',
    description: 'The no parcel message in the parcel component',
  },
  createNewParcelMessage: {
    id: 'parcel.createNewParcelMessage',
    defaultMessage: 'Create a new parcel',
    description: 'The create a new parcel message in the parcel component',
  },
  numberOfItems: {
    id: 'parcel.numberOfItems',
    defaultMessage: 'Number of items: {number}',
    description: 'The number of items message in the parcel component',
  },
  actions: {
    edit: {
      id: 'parcel.actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit action button in the parcel component',
    },
    new: {
      id: 'parcel.actions.new',
      defaultMessage: 'New',
      description: 'label of the new action button in the parcel component',
    },
  },
  feedback: {
    parcelNotCreated: {
      id: 'parcel.feedback.parcelNotCreated',
      defaultMessage: 'Parcel could not be created',
      description: 'Error message for the create parcel action',
    },
    parcelNotSelected: {
      id: 'parcel.feedback.parcelNotSelected',
      defaultMessage: 'Parcel could not be selected',
      description: 'Error message for the select parcel action',
    },
  },
};

export default defineMessages(translations);
